import { AppDispatcher } from 'dispatcher';
import { type RouteQueryProps } from 'utils/RouteUtil';
import { SET_CONTEXTINE_CREDS, STORE_QUERY } from 'vd-constants';

export interface ContextineCreds {
  token: string;
  refreshToken: string;
}

export default {
  storeQuery(query: RouteQueryProps | null = null) {
    AppDispatcher.dispatch(STORE_QUERY, {
      payload: query,
    });
  },

  setContextineCreds(contextineCreds: ContextineCreds) {
    AppDispatcher.dispatch(SET_CONTEXTINE_CREDS, {
      creds: contextineCreds,
    });
  },
};
